import React, { ReactNode } from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { PageDrawer } from "../PageDrawer";
import { AppChartIcon } from "../../Icon/AppChartIcon";
import { VerticalContainer } from "../../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/VerticalContainer";
import { Box, Divider } from "@mui/material";

interface IPageChartFilterDrawerProps {
    buttons: ReactNode;
    children: ReactNode;
    title: string;
    onClose: () => void;
}

export const PageChartFilterDrawer = (props: IPageChartFilterDrawerProps) => (
    <PageDrawer
        open={true}
        icon={<AppChartIcon />}
        title={props.title}
        parentTitle={Translations.Panels}
        fitToContainer
        onClose={props.onClose}
    >
        <VerticalContainer
            minHeight="100%"
            after={
                <>
                    <Divider sx={{ margin: "1rem 0" }} />
                    <Box margin="1rem">
                        {props.buttons}
                    </Box>
                </>
            }
        >
            <Box padding="1rem 24px 0" height="100%" sx={{ overflowY: "auto" }}>
                {props.children}
            </Box>
        </VerticalContainer>
    </PageDrawer>
);
